import { Loader } from "@googlemaps/js-api-loader";

import ENVS from "config/envs";

/** A load that neither succeeds nor fails within this window is treated as failed. */
export const GOOGLE_MAPS_LOAD_TIMEOUT_MS = 15_000;

let placesLibraryPromise: Promise<void> | null = null;

export const ensureGoogleMapsPlacesLoaded = (): Promise<void> => {
  const apiKey = ENVS.googlePlacesApiKey?.trim();
  if (!apiKey) {
    return Promise.reject(new Error("Google Places API key is not configured"));
  }

  if (!placesLibraryPromise) {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    const timeout = new Promise<never>((_, reject) => {
      timeoutId = setTimeout(
        () => reject(new Error("Google Maps Places load timed out")),
        GOOGLE_MAPS_LOAD_TIMEOUT_MS
      );
    });
    const load = new Loader({
      apiKey,
      version: "weekly",
    }).importLibrary("places");

    placesLibraryPromise = Promise.race([load, timeout])
      .then(
        () => undefined,
        (error: unknown) => {
          // Do not cache a failed or hung load: the next caller (e.g. reopening the dialog) retries.
          placesLibraryPromise = null;
          throw error;
        }
      )
      .finally(() => clearTimeout(timeoutId));
  }

  return placesLibraryPromise;
};
